// App
export const APP_INIT = 'APP_INIT';

export const DECREMENT_REQUEST_COUNTER = 'DECREMENT_REQUEST_COUNTER';
export const INCREMENT_REQUEST_COUNTER = 'INCREMENT_REQUEST_COUNTER';
export const RESET_REQUEST_COUNTER = 'RESET_REQUEST_COUNTER';

export const PUSH_SNACKBAR = 'PUSH_SNACKBAR';
export const POP_SNACKBAR = 'POP_SNACKBAR';

export const APP_LAYOUT_CHANGE = 'APP_LAYOUT_CHANGE';

export const WINDOW_RESIZE = 'WINDOW_RESIZE';
export const SITE_INFO_HEIGHT_RECEIVED = 'SITE_INFO_HEIGHT_RECEIVED';

export const SEARCH_MEDICAMENT_REQUEST = 'SEARCH_MEDICAMENT_REQUEST';
export const SEARCH_MEDICAMENT_SUCCESS = 'SEARCH_MEDICAMENT_SUCCESS';
export const SEARCH_MEDICAMENT_ERROR = 'SEARCH_MEDICAMENT_ERROR';

export const CLEAR_MEDICAMENT_SUGGESTIONS = 'CLEAR_MEDICAMENT_SUGGESTIONS';

// Videoconference

// Patient
export const NEW_CONSULTATION = 'NEW_CONSULTATION';

// Form upload
export const CONSULTATION_CREATION = 'CONSULTATION_CREATION';
export const UPLOAD_START = 'UPLOAD_START';
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS';
export const UPLOAD_END = 'UPLOAD_END';
